/* eslint-disable  */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable arrow-spacing */
import Spinner from '@atlaskit/spinner';
import * as lodash from 'lodash';
import React, { useEffect, useState, FC, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';

import { accountService, callService2, meetService } from '../../../../../service';
import { STATUS } from '../../../../../socket/config';
import { SocketContext } from '../../../../../socket/socket.context';
import { sortName, goToRoomWithToken } from '../../../../../utils';
import { Icon, IconAddCircleWhite, IconEmail, IconPhone, IconInviteMore } from '../../../base/icons';
import Card from '../atoms/Card';
import Filter from '../atoms/Filter';
import PhoneBookContactItem from './PhoneBook/ContactItem';

export interface PhoneBookData {
    id: number,
    name: string,
    callInfo: string,
    subName: string,
    isContact: boolean,
    status: string,
    isGroup?: boolean | undefined
}
export interface PhoneBookProps {
    onSubmit?: () => void,
    openAddContact?: () => void,
    openCreateGroup?: ()=> void,
    dataNewGroup?: Array
}

const PhoneBook: FC<PhoneBookProps> = props => {
    // eslint-disable-next-line react/prop-types
    const { onSubmit, openAddContact, openCreateGroup, selectedUserList, addContactList } = props;
    const { contact, user } = useSelector(state => state['features/settings']);
    const { room, conference } = useSelector(state => state['features/base/conference']);
    const [ userData, setUserData ] = useState(contact?.sort(sortName) || []);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ newListUser, setNewListUser ] = useState([]);
    const { usersStatus, groups, sendUserStatus } = useContext(SocketContext);
    const [ simpleSearch, setSimpleSearch ] = useState('');
    const [ error, setError ] = useState('');
    const [selectedContacts, seSelectedContacts] = useState(0)

    const fetchUserData = async keywords => {
        setIsLoading(true);
        try {
            const response = await accountService.getDataContact(keywords);

            setSimpleSearch(keywords);
            setUserData(response.sort(sortName));
        } catch (e) {
            console.log('error', e);
        } finally {
            setIsLoading(false);
        }
    };
    const handleChangeSearch = lodash.debounce(keyword => {
        fetchUserData(keyword);
    }, 500);
    const newUserData = useMemo(() => {
        const groupsContact = groups ? groups?.filter(item => item?.createdBy?.includes(user.id)).map(item => {
            return {
                ...item,
                isGroup: true,
                isContact: false
            };
        }) : [];
        let addGroups = [
            ...userData,
            ...groupsContact
        ];

        if (simpleSearch) {
            addGroups = addGroups.filter(item => item?.name?.toLocaleLowerCase()?.includes(simpleSearch?.toLowerCase()?.trim()));
        }
        if (simpleSearch && addGroups?.length === 0) {
            setError(`We couldn’t find anything for "${simpleSearch}".`);
        } else {
            setError('');
        }
        setNewListUser(addGroups.sort(sortName));
        return addGroups.sort(sortName);
    }, [ userData, groups, contact, simpleSearch ]);

    const onSelectUser = (id, index) => {
        const raw = [ ...newListUser ];
        const userContact = newListUser.find(l => l.id === id);
        const selectContact = { ...userContact,
            isContact: !userContact.isContact };

        raw.splice(index, 1, selectContact);
        setNewListUser([ ...raw ]);
        if(selectContact.isContact){
            seSelectedContacts(selectedContacts => selectedContacts + 1);
        } else {
            seSelectedContacts(selectedContacts => selectedContacts - 1);
        }
        
    };
    const initiateSelectedCall = async (newListUser) => {
        if(!newListUser){
            return;
        }
        const contactIds = [];
        let groupIds = []
        let ringNames = []
        const timeZone = moment.tz.guess();
        newListUser.forEach(l => {
            if(l.isContact){
                console.log(l)
                if(l.isGroup){
                    groupIds.push( l.id)
                    ringNames.push(l.name)
                } else {
                    contactIds.push(l.id)
                    ringNames.push(l.firstName)
                }
                
            }
        });
       
        let ringName;
        if(ringNames.length> 1){
            console.log(ringNames.slice(0,2).join(",").concat(',etc...'))
            ringName = ringNames.slice(0,2).join(",").concat(',etc...')
        } else {
            console.log(ringNames.join(","))
            ringName = ringNames.join(",")
        }

        if (room) {
            //  v2
            await callService2.addMultipleUserFromContactIntoCall(room, contactIds, groupIds,timeZone);
        } else {
            // v2
            await callService2.createMultipleUserCall(groupIds,contactIds,timeZone)
                .then(async res => {
                    const meeting = await meetService.createMeeting(res?.data?.callingHistory?.id, `${user.firstName} ${user.lastName}`,user.email, user.id);
                    const meetingrest = await meetService.getMeetingData(meeting?.data?.id);

                    sendUserStatus(user.id, STATUS.BUSY);
                    goToRoomWithToken(meetingrest.authRoom,meetingrest.token);

                     sessionStorage.setItem(`ringing-${res.data?.callingHistory?.id}`, true);
                     sessionStorage.setItem(`ringing-${res.data?.callingHistory?.id}-firstName`, ringName);
                });

        }
    }

    

    useEffect(() => {
        fetchUserData();

        return () => {
            setNewListUser([]);
        };
    }, [ contact ]);
    
    const renderItem = (item: PhoneBookData, index: number) => {
        
    };

    return (
        <Card className = 'o-phone-book'>
            <div className = { 'o-phone-book-search' }>
                <div className = { 'o-phone-book--w-100' }>
                    <button
                        className = { 'o-phone-book--w-100--create-group' }
                        onClick = { isLoading ? () => {} : () => openCreateGroup(userData) }>
                        Create group
                    </button>
                    {selectedContacts > 1 && <button
                        className = 'o-phone-book-btn-call-selected'
                        onClick = { () => initiateSelectedCall(newListUser) }>Call Selected</button> }  
                    <Icon
                        className = { 'o-phone-book--w-100--add-contact' }
                        onClick = { isLoading ? () => {} : openAddContact }
                        size = { 30 }
                        src = { IconAddCircleWhite } />
                </div>
                <Filter
                    data = { newUserData }
                    onSearch = { keyword => handleChangeSearch(keyword) } />
                {error && <span className = 'error-message-for-search'>{error}</span>}
            </div>
            <div className = 'o-phone-book-list'>
                {isLoading ? <div className = 'o-phone-book-list-spinner'>
                    <Spinner size = { 'large' } />
                </div> : <div>
                    {newListUser && newListUser?.map((item, index) => item?.id !== user?.id && <PhoneBookContactItem key={item.id} selectedUserList={userData} addContactList={addContactList} item={item} index={index} onSelectUser={onSelectUser} />)}
                </div> }
            </div>
            <button
                className = 'o-phone-book-btn-sched'
                onClick = { () => onSubmit(newListUser) }>Schedule a call</button>
        </Card>
    );
};

PhoneBook.defaultProps = {
    onSubmit: () => { },
    openAddContact: () => {},
    openCreateGroup: () => {}
};
export default PhoneBook;
